export const PAYROLL_PAGE = {
  EMPLOYMENT_TYPE_SETUP: "employment-type-setup",
  INCOME: "income",
  DEDUCTION: "deduction",
  WELFARE: "welfare",
  FUND: "fund",
};

export const PAYROLL_PAGE_LIST = Object.values(PAYROLL_PAGE);
